export const sortOrder: any = {
  ASC: 'asc',
  DESC: 'desc',
};